@if (_context) {
    <mat-tab-group class="detail-tabs">
        <mat-tab label="Infos">
            <app-contact-form
                [disabled]="_context.formMode === FormMode.Reading"
                [context]="_context.formContext"
                [contact]="_context.formContext.item"
                (contactUpdated)="onContactUpdated($event)"
                (canceled)="onCanceled($event)"></app-contact-form>
        </mat-tab>
    </mat-tab-group>
}
